import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewChecked,
  ElementRef,
  ViewRef,
  ViewChild,
  Input,
  DoCheck,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ExperiencesService } from '../../services/experiences.service';
import { Router } from '@angular/router';
import {
  Experience,
  FilterText,
  SearchWhereResult,
} from '../../services/interfaces/experiences';
import { kebabCase } from 'lodash';
import { TransparencyService } from '../../utils/transparency.service';
import { TagsService } from '../../utils/tags.service';
import { Observable, Subscription } from 'rxjs';
import * as moment from 'moment';
import {
  TagExpType,
  TagLang,
  TagService,
} from '../../services/interfaces/tags';
import { ExperiencesStateService } from '../../services/experiences-state.service';
import { FavoritesService } from '../../services/favorites.service';
import { GooglePlacesService } from '../../services/google-places.service';
import { forkJoin } from 'rxjs';
import { LanguageService, SupportedLanguage } from '../../services/language.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-experiences',
  templateUrl: './experiences.component.html',
  styleUrl: './experiences.component.scss',
})
export class ExperiencesComponent implements OnInit, OnDestroy, AfterViewChecked, DoCheck {
  @Input() datesText: string | undefined = 'Data o periodo';
  @Input() numPersone: string | undefined = 'Persone';

 

  numberOfExperiences: number = 20;
  experiecesCards: Experience.Short[] = [];
  experiecesCardsEmtpy: any[] = [];
  isLoading = false;
  filters!: Experience.Filter;
  numberIncrementalOfExperiences: number = 16;
  showMap = false;
  locale: 'it' | 'de' | 'en' = 'it';
  private destroy$ = new Subject<void>();
  showMoreButtonVisible = false;
  showMoreNumber = 0;
  types: TagExpType[];
  langs: TagLang[];
  services: TagService[];
  selectedLangs = [];
  selectedServices = [];
  selectedTypes: string[] = [];
  lastCallFilters: Subscription | undefined;
  lastCallFilterWhere: Subscription | undefined;
  rangeDates: Date[] | undefined;
  searchText: string | undefined;
  selectedWhereAdvanced: SearchWhereResult | undefined = undefined;
  filteredWhere: SearchWhereResult[] = [];
  pricePopUpText = 'Prezzo';
  numPaxPopUpText = 'Persone';
  calendarPopUpText = 'Data o periodo';
  closeIcon = 'pi pi-times';
  openIcon = 'pi pi-angle-down';
  priceRangeValues = [0, 999];
  mapBoundCoords: any;
  minDate = new Date();

  numPax: number | undefined;

  iconCalendar = this.openIcon;
  iconPerson = this.openIcon;
  iconPrice = this.openIcon;
  iconLanguage = this.openIcon;
  iconServices = this.openIcon;

  constructor(
    private _router: Router,
    private _experiencesService: ExperiencesService,
    private _transparencyService: TransparencyService,
    private _tagsService: TagsService,
    private elementRef: ElementRef,
    private _stateService: ExperiencesStateService,
    private _favoritesService: FavoritesService,
    private _googlePlacesService: GooglePlacesService,
    private languageService: LanguageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.locale = this.languageService.getCurrentLanguage() as 'it' | 'de' | 'en';
    this.filters = {
      page: 0,
      size: this.numberIncrementalOfExperiences,
      lang: this.locale,
    } as Experience.Filter;
    this._transparencyService.setTransparency(false);
    this.types = _tagsService.getAllTypes(this.locale);
    this.langs = _tagsService.getAllLang(this.locale);
    this.services = _tagsService.getAllServices(this.locale);
  }

  ngAfterViewChecked(): void {
    //TODO
    //this.datesText=moment(this.rangeDates[0]).format("DD-MM-YY");
  }

  ngOnInit(): void {
    // Sottoscrivi al cambio lingua: aggiorna locale, filtri, tag e rifai la ricerca
    this.languageService.currentLanguage$
      .pipe(takeUntil(this.destroy$))
      .subscribe((lang: SupportedLanguage) => {
        const newLocale = lang as 'it' | 'de' | 'en';
        if (newLocale !== this.locale) {
          this.locale = newLocale;
          this.filters.lang = this.locale;
          this.types = this._tagsService.getAllTypes(this.locale);
          this.langs = this._tagsService.getAllLang(this.locale);
          this.services = this._tagsService.getAllServices(this.locale);
          if (isPlatformBrowser(this.platformId)) {
            this.doFilter();
          }
        }
      });

    // Only execute in browser to avoid SSR errors with XMLHttpRequest
    if (isPlatformBrowser(this.platformId)) {
      // Restore state if available
      const savedState = this._stateService.getState();
      if (savedState) {
        this.restoreState(savedState);
        this._stateService.clearState();
      } else {
        this.doFilter();
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngDoCheck(): void {
    if (this.rangeDates != undefined) {
      this.datesText = this.formatDateRange(this.rangeDates);
      this.iconCalendar = this.closeIcon;
      console.log(this.datesText);
    }
    if (this.numPax != undefined) {
      this.numPersone =
        this.numPax > 1
          ? this.numPax.toString() + ' persone'
          : this.numPax.toString() + ' persona';
      this.iconPerson = this.closeIcon;
    }
  }

  doLoadingUI(load: boolean) {
    this.isLoading = load;
    if (load) {
      for (var i = 0; i < this.numberIncrementalOfExperiences; i++) {
        this.experiecesCardsEmtpy.push({});
      }
    } else {
      this.experiecesCardsEmtpy = [];
    }
  }

  doFilter() {
    if (this.lastCallFilters) {
      this.lastCallFilters.unsubscribe();
    }

    this.experiecesCards = [];
    this.resetFilters();

    this.doLoadingUI(true);
    try {
      if (this.showMap) {
        this.filters.size = 150;
      }

      // Add selected services IDs to filters.services
      if (this.selectedServices && this.selectedServices.length > 0) {
        this.filters.services = this.selectedServices.map((x) => x['id']);
      }
      
      // Add selected types to filters.tags
      this.filters.tags = this.filters.tags?.concat(this.selectedTypes);
      this.filters.experienceLanguages = this.selectedLangs.map(
        (x) => x['code']
      );

      if (this.rangeDates && this.rangeDates.length == 2) {
        this.filters.dateFrom = moment
          .utc(this.rangeDates[0])
          .local()
          .format('YYYY-MM-DD');
        this.filters.dateTo = moment
          .utc(this.rangeDates[1])
          .local()
          .format('YYYY-MM-DD');
      } else if (this.rangeDates && this.rangeDates.length == 1) {
        this.filters.dateFrom = moment
          .utc(this.rangeDates[0])
          .local()
          .format('YYYY-MM-DD');
        this.filters.dateTo = moment
          .utc(this.rangeDates[0])
          .local()
          .format('YYYY-MM-DD');
      }

      if (this.numPax && this.numPax > 0) {
        this.filters.adults = this.numPax;
      }

      // Prioritize selected location search over map bounds
      if (this.selectedWhereAdvanced) {
        if (this.selectedWhereAdvanced.shape) {
          this.filters.geoShape = this.selectedWhereAdvanced.shape;
        } else if (this.selectedWhereAdvanced.location && this.selectedWhereAdvanced.location.lat && this.selectedWhereAdvanced.location.lon) {
          // Use lat/long search when location is selected
          this.filters.latitude = this.selectedWhereAdvanced.location.lat;
          this.filters.longitude = this.selectedWhereAdvanced.location.lon;
          switch (this.selectedWhereAdvanced.type) {
            case 'cities':
              this.filters.radius = '20km';
              break;
            case 'provinces':
              this.filters.radius = '50km';
              break;
            case 'regions':
              this.filters.radius = '100km';
              break;
            case 'wine-regions':
              this.filters.radius = '100km';
              break;
            default:
              this.filters.radius = '20km';
              break;
          }
        }
      } else if (this.showMap && this.mapBoundCoords) {
        // Only use map bounds if no location is selected
        this.filters.geoShape = this.mapBoundCoords; //"Envelope"
      }

      if (
        this.priceRangeValues &&
        this.priceRangeValues.length == 2 &&
        this.priceRangeValues[0] > 0
      ) {
        this.filters.priceMin = this.priceRangeValues[0];
        this.filters.priceMax = this.priceRangeValues[1];
      }
    } catch (err) {
      console.error('78654 - Error on filter - ' + err);
    }

    this.lastCallFilters = forkJoin({
      cards: this._experiencesService.listCard(this.filters),
      favorites: this._favoritesService.getFavorites()
    }).subscribe(
      ({ cards, favorites }) => {
        const cleanedCards = this._experiencesService.cleanExperiencesCard(
          cards.data
        );
        // Sort favorites first
        this.experiecesCards = this.sortFavoritesFirst(cleanedCards, favorites);
        this.doLoadingUI(false);
        // Ensure totalElements is a valid number
        const totalElements = cards.totalElements || 0;
        const currentLength = this.experiecesCards.length;
        this.showMoreNumber = Math.max(0, totalElements - currentLength);
        if (this.showMoreNumber > 0) {
          this.showMoreButtonVisible = true;
        } else {
          this.showMoreNumber = 0;
          this.showMoreButtonVisible = false;
        }
        this.lastCallFilters = undefined;
      },
      (err) => {
        console.error('64567 - ERROR ON download DATA - ' + err);
        this.experiecesCards = [];
        this.showMoreNumber = 0;
        this.showMoreButtonVisible = false;
        this.doLoadingUI(false);
      }
    );
  }

  private resetFilters() {
    this.filters.page = 0;
    this.filters.size = this.numberIncrementalOfExperiences;
    this.filters.tags = [];
    this.filters.services = undefined;
    this.filters.geoShape = undefined;
    this.filters.latitude = undefined;
    this.filters.longitude = undefined;
    this.filters.radius = undefined;
    this.filters.dateFrom = undefined;
    this.filters.dateTo = undefined;
    this.filters.adults = undefined;
    this.filters.priceMin = undefined;
    this.filters.priceMax = undefined;
    this.filters.experienceLanguages = undefined;
  }

  linkToExperience(experienceId: string, experienceName: string): void {
    // Save state before navigating
    this.saveState();
    const kebabName = kebabCase(experienceName);
    const url = `experience/${kebabName}__${experienceId}`;
    console.log(url);
    this._router.navigate([url]);
  }

  clickOnExperienceMap(event: Experience.Short) {
    // Save state before navigating
    this.saveState();
    const experienceId = event.id;
    const experienceName = event.title;
    const kebabName = kebabCase(experienceName);
    const url = `experience/${kebabName}__${experienceId}`;
    console.log(url);
    this._router.navigate([url]);
  }

  changeMapBounding(event: any) {
    // event = {"type":"envelope","coordinates":[[46.09628512627805,9.092810307278949],[45.58444699531444,11.056616459622697]]}
    this.mapBoundCoords = event;
    // Only trigger search if no location is selected (to avoid overriding user's location search)
    if (!this.selectedWhereAdvanced) {
      this.doFilter();
    }
  }

  toogleMap() {
    this.showMap = !this.showMap;
    if (this.showMap) {
      // Scroll to the top of the page
      this.elementRef.nativeElement.ownerDocument.documentElement.scrollTop = 0;
      // TODO load more results
      this.doFilter();
    }
  }

  isActive(type: any): boolean {
    if (type && this.selectedTypes && this.selectedTypes.length) {
      // Usa code (metadataValue) invece di id per il backend
      const index = this.selectedTypes.indexOf(type.code);
      return index > -1;
    }
    return false;
  }

  toogleType(type: any) {
    // Usa code (metadataValue) invece di id per il backend
    const index = this.selectedTypes.indexOf(type.code);
    if (index === -1) {
      // If the type code is not found in the array, add it
      this.selectedTypes.push(type.code);
    } else {
      // If the type code is found in the array, remove it
      this.selectedTypes.splice(index, 1);
    }

    this.doFilter();
  }

  changeSearchTextWhere(event: any) {
    const selectedResult = event.value as SearchWhereResult;
    
    // Use the result directly - it already has coordinates and count from searchPlaces
    if (selectedResult && selectedResult.location.lat && selectedResult.location.lon) {
      this.selectedWhereAdvanced = selectedResult;
      this.doFilter();
    } else {
      // If no coordinates yet, the result should have them from loadDetailsForResults
      this.selectedWhereAdvanced = selectedResult;
      this.doFilter();
    }
  }

  changeSearchTextWhereClear() {
    this.selectedWhereAdvanced = undefined;
  }

  filterWhere(event: any) {
    const query = event.query || this.searchText || '';
    
    if (!query || query.trim().length < 2) {
      this.filteredWhere = [];
      return;
    }

    if (this.lastCallFilterWhere) {
      this.lastCallFilterWhere.unsubscribe();
    }

    // Use Google Places API for geographic search
    this.lastCallFilterWhere = this._googlePlacesService
      .searchPlaces(query, this.locale)
      .subscribe({
        next: (searchResults) => {
          this.filteredWhere = searchResults;
        },
        error: (error) => {
          console.error('Error searching places:', error);
          // Fallback to empty results
          this.filteredWhere = [];
        }
      });
  }

  confirmPrice(event: any) {
    this.doFilter();
  }

  confirmNumPax(event: any) {
    this.doFilter();
  }

  onDateRangeChange(event: any) {
    this.doFilter();
  }

  showMore() {
    // Prevent multiple simultaneous requests
    if (this.isLoading || this.lastCallFilters) {
      return;
    }
    
    this.filters.page++;
    this.doLoadingUI(true);
    this.lastCallFilters = forkJoin({
      cards: this._experiencesService.listCard(this.filters),
      favorites: this._favoritesService.getFavorites()
    }).subscribe(
      ({ cards, favorites }) => {
        // Get existing IDs to filter out duplicates
        const existingIds = new Set(this.experiecesCards.map(card => card.id));
        
        // Filter out duplicates from new cards
        const newCards = cards.data.filter(card => !existingIds.has(card.id));
        
        // Only add if there are new cards to avoid unnecessary updates
        if (newCards.length > 0) {
          // Clean new cards
          const cleanedNewCards = this._experiencesService.cleanExperiencesCard(newCards);
          
          // Concatenate existing and new cards
          const allCards = this.experiecesCards.concat(cleanedNewCards);
          
          // Sort favorites first
          this.experiecesCards = this.sortFavoritesFirst(allCards, favorites);
        }
        
        this.doLoadingUI(false);
        
        // Ensure totalElements is a valid number
        const totalElements = cards.totalElements || 0;
        const currentLength = this.experiecesCards.length;
        this.showMoreNumber = Math.max(0, totalElements - currentLength);
        if (this.showMoreNumber > 0) {
          this.showMoreButtonVisible = true;
        } else {
          this.showMoreNumber = 0;
          this.showMoreButtonVisible = false;
        }

        this.lastCallFilters = undefined;
      },
      (err) => {
        console.error('78168 - ERROR ON download DATA - ' + err);
        // Revert page increment on error
        this.filters.page = Math.max(0, this.filters.page - 1);
        this.showMoreNumber = 0;
        this.showMoreButtonVisible = false;
        this.doLoadingUI(false);
        this.lastCallFilters = undefined;
      }
    );
  }

  fieldReset(arg: any): void {
    switch (arg) {
      case 1: {
        //calendar
        if (this.iconCalendar == this.closeIcon && this.rangeDates) {
          this.rangeDates = undefined;
          this.datesText = 'Data o periodo';
          this.iconCalendar = this.openIcon;
        }
        break;
      }
      case 2: {
        //person
        if (this.iconPerson == this.closeIcon && this.numPax) {
          this.numPax = undefined;
          this.numPersone = 'Persone';
          this.iconPerson = this.openIcon;
        }
        break;
      }
      case 3: {
        //prezzo
        if (this.iconPrice == this.closeIcon && this.priceRangeValues) {
          this.priceRangeValues = [];
          this.pricePopUpText = 'Prezzo';
          this.iconPrice = this.openIcon;
        }
        break;
      }
      case 4: {
        //lingua
        if (this.iconLanguage == this.closeIcon && this.selectedLangs) {
          this.selectedLangs = [];
          this.iconLanguage = this.openIcon;
        }
        break;
      }
      case 5: {
        //servizi
        if (this.iconServices == this.closeIcon && this.selectedServices) {
          this.selectedServices = [];
          this.iconServices = this.openIcon;
        }
        break;
      }
      default: {
        break;
      }
    }
  }

  formatDateRange(dates: any) {
    if (!dates || dates.length < 2) {
      return '';
    }

    const [startDate, endDate] = dates;

    const options = { day: 'numeric', month: 'short', year: 'numeric' };

    // Format the start and end dates
    const start = startDate.toLocaleDateString('en-GB', options).split(' ');
    const end = endDate.toLocaleDateString('en-GB', options).split(' ');

    let formattedDateRange;

    if (start[1] === end[1] && start[2] === end[2]) {
      // Same month and year
      formattedDateRange = `${start[0]}-${end[0]} ${start[1]} ${start[2]}`;
    } else {
      // Different month or year
      formattedDateRange = `${start[0]} ${start[1]} ${start[2]} - ${end[0]} ${end[1]} ${end[2]}`;
    }

    return formattedDateRange;
  }

  private saveState(): void {
    const state = {
      selectedLangs: [...this.selectedLangs],
      selectedServices: [...this.selectedServices],
      selectedTypes: [...this.selectedTypes],
      rangeDates: this.rangeDates ? [...this.rangeDates] : undefined,
      numPax: this.numPax,
      priceRangeValues: [...this.priceRangeValues],
      selectedWhereAdvanced: this.selectedWhereAdvanced,
      searchText: this.searchText,
      showMap: this.showMap,
      mapBoundCoords: this.mapBoundCoords ? JSON.parse(JSON.stringify(this.mapBoundCoords)) : null,
      scrollPosition: window.pageYOffset || document.documentElement.scrollTop,
      currentPage: this.filters.page || 0,
      experiecesCards: [...this.experiecesCards],
      datesText: this.datesText || 'Data o periodo',
      numPersone: this.numPersone || 'Persone',
      pricePopUpText: this.pricePopUpText || 'Prezzo',
      iconCalendar: this.iconCalendar,
      iconPerson: this.iconPerson,
      iconPrice: this.iconPrice,
      iconLanguage: this.iconLanguage,
      iconServices: this.iconServices
    };
    this._stateService.saveState(state);
  }

  private restoreState(state: any): void {
    // Restore filters
    this.selectedLangs = state.selectedLangs || [];
    this.selectedServices = state.selectedServices || [];
    this.selectedTypes = state.selectedTypes || [];
    this.rangeDates = state.rangeDates;
    this.numPax = state.numPax;
    this.priceRangeValues = state.priceRangeValues || [0, 999];
    this.selectedWhereAdvanced = state.selectedWhereAdvanced;
    this.searchText = state.searchText;
    
    // Restore map state
    this.showMap = state.showMap || false;
    this.mapBoundCoords = state.mapBoundCoords;
    
    // Restore UI state
    this.datesText = state.datesText || 'Data o periodo';
    this.numPersone = state.numPersone || 'Persone';
    this.pricePopUpText = state.pricePopUpText || 'Prezzo';
    this.iconCalendar = state.iconCalendar || this.openIcon;
    this.iconPerson = state.iconPerson || this.openIcon;
    this.iconPrice = state.iconPrice || this.openIcon;
    this.iconLanguage = state.iconLanguage || this.openIcon;
    this.iconServices = state.iconServices || this.openIcon;
    
    // Reload filters to ensure map bounds and all filters are properly applied
    // This ensures the map is restored to the correct position and filters are applied
    this.doFilter();
    
    // Restore scroll position after view is initialized and data is loaded
    setTimeout(() => {
      window.scrollTo(0, state.scrollPosition || 0);
    }, 300);
  }

  /**
   * Get translated label for place type
   */
  getTypeLabel(type?: string): string {
    switch (type) {
      case 'cities':
        return 'Città';
      case 'provinces':
        return 'Provincia';
      case 'regions':
        return 'Regione';
      case 'wine-regions':
        return 'Regione vitivinicola';
      default:
        return 'Località';
    }
  }

  /**
   * Sort experiences so favorites appear first
   * Frontend-only logic - doesn't affect backend sorting
   */
  private sortFavoritesFirst(
    experiences: Experience.Short[],
    favoriteIds: string[]
  ): Experience.Short[] {
    if (!favoriteIds || favoriteIds.length === 0) {
      return experiences;
    }

    const favoriteSet = new Set(favoriteIds);
    const favorites: Experience.Short[] = [];
    const nonFavorites: Experience.Short[] = [];

    experiences.forEach((exp) => {
      if (exp.id && favoriteSet.has(exp.id)) {
        favorites.push(exp);
      } else {
        nonFavorites.push(exp);
      }
    });

    // Return favorites first, then non-favorites
    return [...favorites, ...nonFavorites];
  }
}
